import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=4afe3e8d"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=4afe3e8d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports